import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_COMPANY_API
const performanceUrl = process.env.VUE_APP_PERFORMANCE_API

/** ********专家入库审核*********** */

// 专家申请分页列表查询接口
export function getExpertAuditListApi(params) {
  return request({
    url: baseUrl + '/expert/libraries/approval-list',
    method: 'get',
    params
  })
}

// 专家审核查询
export function getExpertAuditDetailApi(params) {
  return request({
    url: baseUrl + `/expert/libraries/${params.approvalId}/approval-detail`,
    method: 'get'
  })
}

// 专家入库申请审核
export function auditExpertApi(data) {
  return request({
    url: baseUrl + '/expert/libraries/approval',
    method: 'put',
    data
  })
}

// 获取入库专家详情
export function getExpertWarehouseApi(data) {
  return request({
    url: baseUrl + `/expert/libraries/${data.expertId}/detail`,
    method: 'get'
  })
}

// 修改专家入库状态
export function changeExpertWarehouseStatusApi(data) {
  return request({
    url: baseUrl + `/expert/libraries/expert-status`,
    method: 'put',
    data
  })
}

// 添加专家
export function addExpertWarehouseApi(data) {
  return request({
    url: baseUrl + `/expert/libraries/add`,
    method: 'post',
    data
  })
}

// 修改专家专业
export function updateExpertWarehouseApi(data) {
  return request({
    url: baseUrl + `/expert/libraries/major`,
    method: 'put',
    data
  })
}

/** **********专业管理********* */

// 新增企业自有专业
export function addCompanyMajorApi(data) {
  return request({
    url: baseUrl + '/expert/major',
    method: 'post',
    data
  })
}

// 修改企业自有专业
export function updateCompanyMajorApi(data) {
  return request({
    url: baseUrl + '/expert/major',
    method: 'put',
    data
  })
}

// 启停用自有专业
export function changeCompanyMajorStatusApi(data) {
  return request({
    url: baseUrl + '/expert/major/status',
    method: 'put',
    data
  })
}

// 查询所有自有专业
export function getAllCompanyMajorApi(params) {
  return request({
    url: baseUrl + '/expert/major/allMajor',
    method: 'get',
    params
  })
}

// 查询所有平台专业
export function getAllPlatformMajorApi(params) {
  return request({
    url: baseUrl + '/expert/major/platform-allMajor',
    method: 'get',
    params
  })
}

// 专家根据专业分页查询
export function getExpertByMajorApi(params) {
  return request({
    url: baseUrl + `/expert/libraries/search`,
    method: 'get',
    params
  })
}

// 专家查询
export function getExpertListApi(params) {
  return request({
    url: baseUrl + '/expert/search',
    method: 'get',
    params
  })
}

// 专家详情查询
export function getExpertDetailApi(params) {
  return request({
    url: baseUrl + `/expert/enterprise/${params.expertId}/detail`,
    method: 'get'
  })
}

/** *****抽取******* */
// 专家抽取
export function extractExpertApi(data) {
  return request({
    url: baseUrl + `/expert/extracts/order`,
    method: 'post',
    data
  })
}

// 获取专家抽取列表
export function getExtractExpertListApi(params) {
  return request({
    url: baseUrl + `/expert/extracts/page`,
    method: 'get',
    params
  })
}

// 根据专业查询满足的专家
export function getMeetExpertInfoApi(data) {
  return request({
    url: baseUrl + `/expert/extracts/auto/majors/supplement-nums`,
    method: 'post',
    data
  })
}

// 根据抽取单和专业查询满足的专家
export function getMeetExpertByExtractApi(data, extractId) {
  return request({
    url: baseUrl + `/expert/extracts/${extractId}/auto/majors/supplement-nums`,
    method: 'post',
    data
  })
}

// 专家抽取详情
export function getExpertExtractDetailApi(params) {
  return request({
    url: baseUrl + `/expert/extracts/${params.extractId}/order-detail`,
    method: 'get'
  })
}

// 专家抽取通知列表
export function getExpertExtractNoticeListApi(params, isRefreshLoading = true) {
  return request(
    {
      url: baseUrl + `/expert/extracts/${params.extractId}/result`,
      method: 'get'
    },
    isRefreshLoading
  )
}

// 手动抽取专家
export function manualAddExpertApi(data, extractId) {
  return request({
    url: baseUrl + `/expert/extracts/${extractId}/manual/experts`,
    method: 'post',
    data
  })
}
// 手动选择采购人专家
export function manualAddPurchaserExpertApi(data, extractId) {
  return request({
    url: baseUrl + `/expert/extracts/${extractId}/all/experts/of-purchase`,
    method: 'post',
    data
  })
}

// 线下通知更新通知状态
export function manualUpdateNoticeResultApi(data, extractId) {
  return request({
    url:
      baseUrl +
      `/expert/extracts/${extractId}/all/majors/experts/offline-notify`,
    method: 'put',
    data
  })
}

// 补抽
export function supplementExtractNoticeApi(data, extractId) {
  return request({
    url: baseUrl + `/expert/extracts/${extractId}/auto/experts/make-up`,
    method: 'post',
    data
  })
}

// 重新抽取
export function extractAgainApi(data, extractId) {
  return request({
    url: baseUrl + `/expert/extracts/${extractId}/auto/majors`,
    method: 'post',
    data
  })
}

// 分页查询可以手动抽取专家的范围
export function getManualExpertScopeApi(params) {
  return request({
    url:
      baseUrl +
      `/expert/extracts/${params.extractId}/manual/experts/scope/page`,
    method: 'get',
    params
  })
}

// 分页查询专家库专家
export function getManualExpertApi(params) {
  return request({
    url: baseUrl + `/expert/libraries/search`,
    method: 'get',
    params
  })
}

// 继续线上通知
export function goToNotifyApi(params) {
  return request({
    url: baseUrl + `/expert/extracts/${params.extractId}/goto-notify`,
    method: 'put'
  })
}

// 直接从平台选择采购人专家 (选择采购人)
export function addPurchaserExpertFromPlatformApi(data, extractId) {
  return request({
    url: baseUrl + `/expert/extracts/${extractId}/platform/experts/of-purchase`,
    method: 'post',
    data
  })
}

// 登记子抽取单
export function addAbnormalExtractApi(data, extractId) {
  return request({
    url: baseUrl + `/expert/extracts/${extractId}/child/order`,
    method: 'post',
    data
  })
}

/** ******** 电子开评标手动添加专家相关接口 *********** */
// 查询是否拥有专家身份
export function getExpertIdentityApi(params) {
  return request({
    url: baseUrl + `/expert/check-identity`,
    method: 'get',
    params
  })
}

// 查询专家身份信息
export function getExpertIdentityInfoApi(params) {
  return request({
    url: baseUrl + '/expert/expert-info',
    method: 'get',
    params
  })
}

// 注册专家
export function registerExpertApi(data) {
  return request({
    url: baseUrl + '/expert/register-expert',
    method: 'post',
    data
  })
}

// 注册专家v2-支持部分认证信息填写
export function registerExpertV2Api(data) {
  return request({
    url: baseUrl + '/expert/v2/register-expert',
    method: 'post',
    data
  })
}

/** *********专家费管理********** */

// 编辑后提交专家费支付单
export function submitUpdateExpertFeeOrderApi(data, expertFeeOrderId) {
  return request({
    url: baseUrl + `/expert/fee/pay-orders/${expertFeeOrderId}/submit`,
    method: 'put',
    data
  })
}

// 直接提交专家费支付单
export function submitExpertFeeOrderApi(data) {
  return request({
    url: baseUrl + `/expert/fee/pay-orders/submit`,
    method: 'post',
    data
  })
}

// 专家费支付单详情
export function getExpertFeeOrderDetailApi(expertFeeOrderId) {
  return request({
    url: baseUrl + `/expert/fee/pay-orders/${expertFeeOrderId}/detail`,
    method: 'get'
  })
}

// 专家费支付单总额
export function getExpertFeeOrderSumApi() {
  return request({
    url: baseUrl + `/expert/fee/pay-orders/count`,
    method: 'get'
  })
}

// 分页查询专家费支付单
export function getExpertFeeOrderListApi(params) {
  return request({
    url: baseUrl + `/expert/fee/search`,
    method: 'get',
    params
  })
}

// 重新提交专家费审批
export function submitExpertFeeOrderFlowApi(expertFeeOrderId) {
  return request({
    url: baseUrl + `/expert/fee/pay-orders/${expertFeeOrderId}/submit-flow`,
    method: 'post'
  })
}

// 分页查询专家费支付单明细
export function getFeeDetailListApi(params) {
  return request({
    url: baseUrl + `/expert/fee/search/item`,
    method: 'get',
    params
  })
}

// 分页查询专家费支付单明细
export function getFeeDetailItemApi(params) {
  return request({
    url: baseUrl + `/expert/fee/search/item/detail`,
    method: 'get',
    params
  })
}

// 分页查询专家费支付单专家信息
export function getFeeExpertDetailApi(params) {
  return request({
    url: baseUrl + `/expert/fee/item/detail`,
    method: 'get',
    params
  })
}

// 发起打款
export function submitExpertFeePayApi(orderNo) {
  return request({
    url: baseUrl + `/expert/fee/push/task?orderNo=${orderNo}`,
    method: 'post'
  })
}

// ---- 履约验收 ----
// 查询履约任务列表
export function getPerformanceTaskPageApi(params) {
  return request({
    url: performanceUrl + '/performance/task/page',
    method: 'get',
    params
  })
}
